import { render, staticRenderFns } from "./DiscoveryTab.vue?vue&type=template&id=669f94a0&"
import script from "./DiscoveryTab.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports